/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import PaginationItem from '@mui/material/PaginationItem';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import PropTypes from 'prop-types';

const PaginationButtons = ({
  currentPage,
  pageSize,
  paginatedData,
  filteredSortedData,
  handlePageChange,
  totalPages,
  totalRecords,
  isBackendPaginated,
}) => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 364);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let startRecord =
    filteredSortedData.length === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  let endRecord = (currentPage - 1) * pageSize + paginatedData.length;

  if (isBackendPaginated) {
    if (totalRecords === 0) {
      startRecord = 0;
      endRecord = 0;
    } else {
      startRecord = (currentPage - 1) * pageSize + 1;
      endRecord = Math.min(currentPage * pageSize, totalRecords);
    }
  }
  

  return (
    <div className="pagination-container">
      <div className="pagination-info">
      Showing {startRecord}-{endRecord} of {totalRecords || filteredSortedData.length} records
      </div>
      <Stack className="pagination-controls">
        <Pagination
          page={currentPage}
          count={totalPages || Math.ceil(filteredSortedData.length / pageSize)}
          showFirstButton
          showLastButton
          shape="rounded"
          variant="outlined"
          siblingCount={0}
          boundaryCount={isMobileView ? 0 : 1}
          onChange={handlePageChange}
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: KeyboardDoubleArrowLeftIcon,
                last: KeyboardDoubleArrowRightIcon,
              }}
              {...item}
            />
          )}
        />
      </Stack>
    </div>
  );
};

PaginationButtons.defaultProps = {
  isBackendPaginated: false,
};

PaginationButtons.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  paginatedData: PropTypes.array.isRequired,
  filteredSortedData: PropTypes.array.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  totalPages:PropTypes.any.isRequired,
  totalRecords:PropTypes.any.isRequired,
  isBackendPaginated: PropTypes.bool, 
};

export default PaginationButtons;
